import selectController from "./controllers/components/select";
import heroController from "./controllers/sections/heroController";
import filtersController from "./controllers/sections/filtersController";
import plantsResultsController from "./controllers/sections/plantsResultsController";

selectController();
heroController();
filtersController();
plantsResultsController();
